module.exports = __webpack_public_path__ + "static/img/bishnu.577199f4.png";